<template>
  <div class="row-placeholder d-inline-flex min-w-100">
    <div class="row no-gutters flex-nowrap min-w-100">
      <div class="title-cell col text-secondary d-flex thin text-medium-1">
        <div class="cell p-0 flex-grow-1 d-flex align-items-center">
          <input class="checkbox" type="checkbox" disabled />
          <div
            class="flex-grow-1 ml-1 pl-1 placeholder d-flex align-items-center h-100"
            @click="$emit('click')"
          >
            Add an Initiative
          </div>
        </div>
      </div>
      <div
        class="cell text-center flex-shrink-0"
        :class="{ 'last-column': index === sortedFields.length - 1 }"
        v-for="(field, index) in sortedFields"
        :key="field.id"
        :style="{ width: `${field.width}px` }"
      ></div>
      <div class="overflow-plc"></div>
    </div>
  </div>
</template>

<script>
import sortInitiativeFields from '@/utils/sortInitiativeFields'

/**
 * This is a placeholder component for InitiativeRow. User can click on this to add new initiative
 */
export default {
  name: 'AddInitiativePlaceholder',
  props: ['fieldsToDisplay'],
  components: {},
  data() {
    return {}
  },
  computed: {
    sortedFields() {
      return sortInitiativeFields(this.fieldsToDisplay)
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import './styles/rowCellStyles';

.row-placeholder {
  height: 36px;
}
.row-placeholder:hover .title-cell .placeholder {
  background-color: $quinary;
  cursor: text;
}
.cell {
  border-bottom: 1px solid $borderPrimary;
  border-top: 1px solid $borderPrimary;
  &:not(.last-column) {
    border-right: 1px solid $borderPrimary;
  }
}
.checkbox {
  width: 13px;
}
</style>
